import { render, staticRenderFns } from "./ItemComp.vue?vue&type=template&id=50673a34&scoped=true&"
import script from "./ItemComp.vue?vue&type=script&lang=js&"
export * from "./ItemComp.vue?vue&type=script&lang=js&"
import style0 from "./ItemComp.vue?vue&type=style&index=0&id=50673a34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50673a34",
  null
  
)

export default component.exports